(function () {
  const CFG = window.expressConfig || { enabled: true, days: '1,2,3,4,5', start: 11, end: 19 };
  const KEYWORD = 'Express';
  const NOTE = 'Το Express είναι διαθέσιμο ΔΕΥ-ΠΑΡ 11:00-19:00. '
             + 'Τώρα η πρόβλεψή σου έρχεται μέσα σε 24 ώρες.';
  const DAY_NUM = { Mon:1, Tue:2, Wed:3, Thu:4, Fri:5, Sat:6, Sun:7 };

  function athensOpen() {
    if (!CFG.enabled) return false;
    const parts = new Intl.DateTimeFormat('en-GB', {
      timeZone: 'Europe/Athens', weekday: 'short', hour: 'numeric', hour12: false
    }).formatToParts(new Date());
    const day  = DAY_NUM[parts.find(p => p.type === 'weekday').value];
    const hour = parseInt(parts.find(p => p.type === 'hour').value, 10) % 24;
    const allowed = String(CFG.days).split(',').map(Number);
    return allowed.includes(day) && hour >= Number(CFG.start) && hour < Number(CFG.end);
  }

  if (athensOpen()) return;

  function addNote(fieldset) {
    if (!fieldset || fieldset.querySelector('.express-closed-note')) return;
    const p = document.createElement('p');
    p.className = 'express-closed-note';
    p.textContent = NOTE;
    fieldset.appendChild(p);
  }

  function prune(root) {
  // Swatch / radio style
  root.querySelectorAll('input.product-swatch-option').forEach(input => {
    if (!input.value.includes(KEYWORD)) return;
    const li = input.closest('li.product-variant--item');
    if (!li || li.dataset.expressDisabled) return;

    const wasChecked = input.checked;
    li.dataset.expressDisabled = '1';
    li.classList.add('express-unavailable');
    input.disabled = true;
    input.setAttribute('aria-disabled', 'true');

    const fieldset = input.closest('fieldset.product-variant--picker');
    addNote(fieldset);

    if (wasChecked && fieldset) {
      const alt = fieldset.querySelector('input.product-swatch-option:not([disabled])');
      if (alt) {
        alt.checked = true;
        alt.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });

  // Select style
  root.querySelectorAll('select.options-select').forEach(select => {
    let touched = false, wasSelected = false;

    Array.from(select.options).forEach(opt => {
      if (!opt.value.includes(KEYWORD) || opt.dataset.expressDisabled) return;
      opt.dataset.expressDisabled = '1';
      opt.disabled = true;
      opt.textContent = opt.textContent.trim() + ' — μη διαθέσιμο';
      if (opt.selected) wasSelected = true;
      touched = true;
    });

    if (!touched) return;
    addNote(select.closest('fieldset.product-variant--picker'));

    if (wasSelected) {
      const alt = Array.from(select.options).find(o => !o.disabled);
      if (alt) {
        select.value = alt.value;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }
  });
}

  const run = () => document.querySelectorAll('variant-set-option').forEach(prune);

  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(run).observe(document.body, { childList: true, subtree: true });
})();